var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unlink_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".unlink_svg__dy{fill:url(#unlink_svg__ds)}.unlink_svg__dz{fill:url(#unlink_svg__dw)}.unlink_svg__ea{fill:url(#unlink_svg__dv)}.unlink_svg__eb{fill:#272727}.unlink_svg__ec{fill:url(#unlink_svg__dx)}.unlink_svg__ed{fill:url(#unlink_svg__du)}.unlink_svg__ee{fill:url(#unlink_svg__dt)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__ds",
    x1: 28,
    y1: 140.77,
    x2: 108.24,
    y2: 140.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__dt",
    x1: 70.56,
    y1: 102.89,
    x2: 136.52,
    y2: 102.89,
    xlinkHref: "#unlink_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__du",
    x1: 116.52,
    y1: 67.47,
    x2: 165.87,
    y2: 67.47,
    xlinkHref: "#unlink_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__dv",
    x1: 292.24,
    y1: 325.99,
    x2: 358.19,
    y2: 325.99,
    xlinkHref: "#unlink_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__dw",
    x1: 320.51,
    y1: 288.11,
    x2: 400.75,
    y2: 288.11,
    xlinkHref: "#unlink_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlink_svg__dx",
    x1: 262.89,
    y1: 361.41,
    x2: 312.24,
    y2: 361.41,
    xlinkHref: "#unlink_svg__ds"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__eb",
    d: "m69.02,360.77c18.33,18.12,42.38,28.09,67.79,28.09h.01c11.92,0,23.49-2.22,34.39-6.6,11.32-4.55,21.44-11.25,30.08-19.9l56.53-56.67c4.79-4.8,4.78-12.6-.02-17.4-2.32-2.32-5.41-3.59-8.69-3.59s-6.38,1.28-8.71,3.61l-56.53,56.67c-6.27,6.29-13.62,11.15-21.83,14.45-7.97,3.2-16.45,4.83-25.22,4.83-18.89,0-36.8-7.45-50.5-20.97l-.59-.59c-13.77-13.75-21.35-31.84-21.35-50.93,0-8.75,1.62-17.23,4.8-25.19,3.29-8.21,8.12-15.55,14.38-21.82l56.53-56.67c2.32-2.33,3.6-5.42,3.59-8.7,0-3.29-1.29-6.37-3.61-8.69-2.32-2.32-5.41-3.59-8.69-3.59s-6.38,1.28-8.71,3.61l-56.53,56.67c-8.62,8.64-15.28,18.75-19.8,30.05-4.36,10.88-6.56,22.43-6.56,34.33,0,25.66,10.14,49.93,28.57,68.34l.67.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__eb",
    d: "m346.08,183.2l-56.54,56.67c-4.79,4.8-4.78,12.6.02,17.39,2.32,2.32,5.41,3.59,8.69,3.59s6.38-1.28,8.71-3.61l56.53-56.67c8.62-8.64,15.28-18.75,19.8-30.05,4.36-10.88,6.56-22.43,6.56-34.33,0-25.66-10.14-49.93-28.57-68.34h0s-.28-.28-.28-.28c-18.38-18.36-42.59-28.48-68.19-28.48-11.92,0-23.49,2.22-34.39,6.6-11.32,4.55-21.44,11.24-30.08,19.9l-56.53,56.67c-2.32,2.33-3.6,5.42-3.59,8.7,0,3.29,1.29,6.37,3.61,8.69,2.32,2.32,5.41,3.59,8.69,3.59h0c3.29,0,6.38-1.28,8.71-3.61l56.53-56.67c6.27-6.29,13.62-11.15,21.83-14.45,7.97-3.2,16.45-4.83,25.22-4.83,19.03,0,37.07,7.56,50.79,21.27l.29.3c13.77,13.75,21.35,31.84,21.35,50.93,0,8.75-1.62,17.23-4.8,25.19-3.29,8.21-8.12,15.55-14.38,21.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__dy",
    d: "m95.93,165.8c4.8,0,9.19-2.82,11.19-7.19,2.82-6.17.1-13.48-6.07-16.3l-55.63-25.46c-1.62-.74-3.34-1.12-5.11-1.12-4.8,0-9.19,2.82-11.19,7.18-2.82,6.17-.1,13.48,6.07,16.3l55.63,25.46c1.62.74,3.34,1.12,5.11,1.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__ee",
    d: "m132.92,114.88l-41.37-41.36c-2.32-2.32-5.41-3.6-8.7-3.6s-6.37,1.28-8.7,3.6-3.6,5.41-3.6,8.7,1.28,6.38,3.6,8.7l41.36,41.37c2.32,2.32,5.41,3.6,8.7,3.6s6.37-1.28,8.7-3.6c4.8-4.79,4.8-12.6,0-17.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__ed",
    d: "m142.31,100.59c1.96,4.47,6.38,7.35,11.26,7.35,1.71,0,3.37-.35,4.94-1.04,3.01-1.32,5.32-3.74,6.51-6.8s1.12-6.4-.2-9.41l-24.75-56.34c-1.96-4.47-6.38-7.35-11.26-7.35-1.71,0-3.37.35-4.94,1.04-6.21,2.73-9.04,10-6.31,16.21l24.75,56.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__ea",
    d: "m295.84,314l41.37,41.37c2.32,2.32,5.41,3.6,8.7,3.6s6.37-1.28,8.7-3.6c4.79-4.8,4.79-12.6,0-17.4l-41.37-41.36c-2.32-2.32-5.41-3.6-8.7-3.6s-6.37,1.28-8.7,3.6c-4.8,4.79-4.8,12.6,0,17.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__dz",
    d: "m393.57,289.65l-55.63-25.46c-1.62-.74-3.34-1.12-5.11-1.12-4.8,0-9.19,2.82-11.19,7.18-1.37,2.99-1.49,6.33-.34,9.41,1.15,3.08,3.42,5.53,6.41,6.89l55.64,25.46c1.62.74,3.34,1.12,5.11,1.12,4.8,0,9.19-2.82,11.19-7.18,2.82-6.17.1-13.48-6.07-16.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "unlink_svg__ec",
    d: "m299.94,401.88c1.71,0,3.37-.35,4.94-1.04,6.21-2.73,9.04-10,6.31-16.21l-24.75-56.34c-1.96-4.47-6.38-7.35-11.27-7.35-1.71,0-3.37.35-4.94,1.04-6.21,2.73-9.04,10-6.31,16.21l24.75,56.34c1.96,4.47,6.38,7.36,11.27,7.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.8c098c29fcaf8fd45fb45cf5ad5b947c.svg";
export { ForwardRef as ReactComponent };